const currencies = {
    HUF: 'HUF',
    EUR: 'EUR'
}

const paymentMethods = {
    ARUHITEL: 'aruhitel',
    BANKCARD: 'bankcard',
    BARION: 'barion',
    BARTER: 'barter',
    CASH: 'cash',
    CASH_ON_DELIVERY: 'cash_on_delivery',
    COUPON: 'coupon',
    ELORE_UTALAS: 'elore_utalas',
    EP_KARTYA: 'ep_kartya',
    KOMPENZACIO: 'kompenzacio',
    LEVONAS: 'levonas',
    ONLINE_BANKCARD: 'online_bankcard',
    OTHER: 'other',
    PAYLIKE: 'paylike',
    PAYONEER: 'payoneer',
    PAYPAL: 'paypal',
    PAYPAL_UTOLAG: 'paypal_utolag',
    PAYU: 'payu',
    PICK_PACK_PONT: 'pick_pack_pont',
    POSTAI_CSEKK: 'postai_csekk',
    POSTAUTALVANY: 'postautalvany',
    SKRILL: 'skrill',
    SZEP_CARD: 'szep_card',
    TRANSFERWISE: 'transferwise',
    UPWORK: 'upwork',
    UTALVANY: 'utalvany',
    VALTO: 'valto',
    WIRE_TRANSFER: 'wire_transfer'
}

const unitPriceTypes = {
    BRUTTO: 'gross',
    NETTO: 'net'
}

const units = {
    PIECE: 'darab',
    DAY: 'nap',
    MONTH: 'hónap',
}

const vat = {
    NORMAL:'27%',
    DISCOUNT_0:'0%',
    DISCOUNT_5:'5%',
    DISCOUNT_18:'18%',
}

const deliveryTypes = {
    DHL: 'dhl',
    GLS: 'gls',
    TGS_OFFICE: 'TGS Iroda',
    HAND: 'Kézbe',
}

const invoiceTypes = {
    InvoiceBankTransfer: "Banki utalás",
    InvoiceCash: "Készpénz",
    // Cash: "Cash",
    InvoiceCreditCard: "Bankkártyás",
    Compensation: "Kompenzáció"
}

const deliveryPeriods = {
    EN: "EN",
    DU: "DU",
    DE: "DE",
}

const deliveryFormats = {
    Backpack: "Backpack",
    Case: "Case",
}

const orderStatuses = {
    ordered: 'ordered',
    confirmed: 'confirmed',
    packaging: 'packaging',
    delivering: 'delivering',
    out: 'out',
    returned: 'returned',
    closed: 'closed',
    invalid: 'invalid',
}

export {
    currencies,
    paymentMethods,
    unitPriceTypes,
    units,
    vat,
    deliveryTypes,
    invoiceTypes,
    deliveryPeriods,
    // programs,
    deliveryFormats,
    orderStatuses
}